<template>
    <div class="container">
        <Progress :stage="3"/>
        <div class="section-paragraph" v-if="language==='zh'" v-html="flightContent"></div>
        <div class="section-paragraph" v-if="language==='en'" v-html="flightContentEn"></div>
        <a-form @submit="handleSubmit" :form="form" class="flight-form" id="flight-form">
            <div class="flight-section" :class="{active: flightObj.book_mode === 1}">
                <div class="flight-header" @click="toggleSheet(1)">{{getLabel('FLIGHT_SECTION_TITLE1')}}</div>
                <div class="flight-content" v-show="flightObj.book_mode === 1">
                    <a-row class="flight-logo">
                        <a-col :span="10">
                            <h1 class="flight-title">{{getLabel('FLIGHT_GO_TITLE')}}</h1>
                            <a-form-item
                                :wrapperCol="{ span: 24 }"
                            >
                                <a-auto-complete
                                    :dataSource="goCityShowList"
                                    size="large"
                                    v-decorator="['from_city', {rules: [{ required: flightObj.book_mode === 1 && canModify, message: getLabel('TIP_REQUIRED') }]}]"
                                    @search="fetchGoCity"
                                    :placeholder="getLabel('FLIGHT_GO_LABEL1')"
                                >
                                </a-auto-complete>
                            </a-form-item>
                            <a-form-item
                                :wrapperCol="{ span: 24 }"
                            >
                                <a-locale-provider :locale="language === 'zh' ? zhCN : en_US">
                                    <a-date-picker
                                        :disabled="!canModify"
                                        size="large"
                                        :defaultPickerValue="moment('2020-05-08', 'YYYY-MM-DD')"
                                        :placeholder="getLabel('FLIGHT_GO_LABEL2')"
                                        v-decorator="['go_date', {rules: [{ required: flightObj.book_mode === 1 && canModify, message: getLabel('TIP_REQUIRED') }]}]" style="width: 100%"/>
                                </a-locale-provider>
                            </a-form-item>
                            <a-input-group compact size="large">
                                <a-select :value="leftChoice" style="width: 151px" @change="changeLeftChoice">
                                    <a-select-option :value="1">{{getLabel('FLIGHT_NO')}}</a-select-option>
                                    <a-select-option :value="2">{{getLabel('FLIGHT_SPAN')}}</a-select-option>
                                </a-select>
                                <a-form-item v-show="leftChoice === 1">
                                    <a-input
                                        :disabled="!canModify"
                                        :placeholder="getLabel('FLIGHT_GO_LABEL3')"
                                        size="large" style="width: 249px"
                                        class="flight-noInput"
                                        v-decorator="['go_flight_no', {rules: [{ required: (flightObj.book_mode === 1 && leftChoice === 1) && canModify, message: getLabel('TIP_REQUIRED') }]}]" autocomplete="off"/>
                                </a-form-item>
                                <a-form-item v-show="leftChoice === 2" class="time-picker-row">
                                    <a-select
                                        :placeholder="getLabel('FLIGHT_START')"
                                        v-decorator="['go_time_begin', {
                                            rules: [
                                                { required: (flightObj.book_mode === 1 && leftChoice === 2) && canModify, message: getLabel('TIP_REQUIRED')},
                                                { validator: checkGoTimeBegin }
                                            ]
                                        }]"
                                        showSearch
                                        class="left-hour-picker"
                                        :disabled="!canModify"
                                        style="width: 113px"
                                        size="large"
                                        @change="value => timeChange('go_time_begin', 'go_time_end',value)"
                                    >
                                        <a-select-option
                                            v-for="(hour, index) in hourList"
                                            :key="'go_begin_' + index"
                                            :value="hour"
                                        >{{hour}}</a-select-option>
                                    </a-select>
                                </a-form-item>
                                <span
                                    :style="{ display: 'inline-block', width: '24px', textAlign: 'center', height: '40px', lineHeight: '40px' }"
                                    v-show="leftChoice === 2"
                                >-</span>
                                <a-form-item v-show="leftChoice === 2">
                                    <a-select
                                        v-decorator="['go_time_end', {rules: [{ required: (flightObj.book_mode === 1 && leftChoice === 2) && canModify, message: getLabel('TIP_REQUIRED') }]}]"
                                        showSearch
                                        :disabled="!canModify"
                                        style="width: 113px"
                                        size="large"
                                        :placeholder="getLabel('FLIGHT_END')"
                                        @change="value => timeChange('go_time_end', 'go_time_begin',value)"
                                    >
                                        <a-select-option
                                            v-for="(hour, index) in hourList"
                                            :key="'go_end_' + index"
                                            :value="hour"
                                        >{{hour}}</a-select-option>
                                    </a-select>
                                </a-form-item>
                            </a-input-group>
                        </a-col>
                        <a-col :span="4"></a-col>
                        <a-col :span="10">
                            <h1 class="flight-title">{{getLabel('FLIGHT_RETURN_TITLE')}}</h1>
                            <a-form-item
                                :wrapperCol="{ span: 24 }"
                            >
                                <a-auto-complete
                                    :dataSource="returnCityShowList"
                                    size="large"
                                    v-decorator="['to_city', {rules: [{ required: flightObj.book_mode === 1 && canModify, message: getLabel('TIP_REQUIRED') }]}]"
                                    @search="fetchReturnCity"
                                    :placeholder="getLabel('FLIGHT_RETURN_LABEL1')"
                                >
                                </a-auto-complete>
                            </a-form-item>
                            <a-form-item
                                :wrapperCol="{ span: 24 }"
                            >
                                <a-locale-provider :locale="language === 'zh' ? zhCN : en_US">
                                    <a-date-picker
                                        :disabled="!canModify"
                                        size="large"
                                        :defaultPickerValue="moment('2020-05-12', 'YYYY-MM-DD')"
                                        :placeholder="getLabel('FLIGHT_RETURN_LABEL2')"
                                        v-decorator="['return_date', {rules: [{ required: flightObj.book_mode === 1 && canModify, message: getLabel('TIP_REQUIRED') }]}]" style="width: 100%"/>
                                </a-locale-provider>
                            </a-form-item>
                            <a-input-group compact size="large">
                                <a-select :value="rightChoice" style="width: 151px" @change="changeRightChoice">
                                    <a-select-option :value="1">{{getLabel('FLIGHT_NO')}}</a-select-option>
                                    <a-select-option :value="2">{{getLabel('FLIGHT_SPAN')}}</a-select-option>
                                </a-select>
                                <a-form-item v-show="rightChoice === 1">
                                    <a-input
                                        :disabled="!canModify"
                                        :placeholder="getLabel('FLIGHT_RETURN_LABEL3')"
                                        size="large" style="width: 249px"
                                        class="flight-noInput"
                                        v-decorator="['return_flight_no', {rules: [{ required: (flightObj.book_mode === 1 && rightChoice === 1) && canModify, message: getLabel('TIP_REQUIRED') }]}]" autocomplete="off"/>
                                </a-form-item>
                                <a-form-item v-show="rightChoice === 2" class="time-picker-row">
                                    <a-select
                                        :placeholder="getLabel('FLIGHT_START')"
                                        v-decorator="['return_time_begin', {
                                            rules: [
                                                { required: (flightObj.book_mode === 1 && rightChoice === 2) && canModify, message: getLabel('TIP_REQUIRED')},
                                                { validator: checkReturnTimeBegin }
                                            ]
                                        }]"
                                        showSearch
                                        class="left-hour-picker"
                                        :disabled="!canModify"
                                        style="width: 113px"
                                        size="large"
                                        @change="value => timeChange('return_time_begin', 'return_time_end',value)"
                                    >
                                        <a-select-option
                                            v-for="(hour, index) in hourList"
                                            :key="'return_begin_' + index"
                                            :value="hour"
                                        >{{hour}}</a-select-option>
                                    </a-select>
                                </a-form-item>
                                <span
                                    :style="{ display: 'inline-block', width: '24px', textAlign: 'center', height: '40px', lineHeight: '40px' }"
                                    v-show="rightChoice === 2"
                                >-</span>
                                <a-form-item v-show="rightChoice === 2">
                                    <a-select
                                        :placeholder="getLabel('FLIGHT_START')"
                                        v-decorator="['return_time_end', {rules: [{ required: (flightObj.book_mode === 1 && rightChoice === 2) && canModify, message: getLabel('TIP_REQUIRED') }]}]"
                                        showSearch
                                        class="left-hour-picker"
                                        :disabled="!canModify"
                                        style="width: 113px"
                                        size="large"
                                        @change="value => timeChange('return_time_end', 'return_time_begin',value)"
                                    >
                                        <a-select-option
                                            v-for="(hour, index) in hourList"
                                            :key="'return_end_' + index"
                                            :value="hour"
                                        >{{hour}}</a-select-option>
                                    </a-select>
                                </a-form-item>
                            </a-input-group>
                        </a-col>

                    </a-row>
                    <a-row class="flight-dark">
                        <a-form-item
                            :label="getLabel('INFORMATION_RIGHT3_LABEL')"
                            :labelCol="{ span: language === 'zh' ? 3 : 4 }"
                            :wrapperCol="{ span: language === 'zh' ? 21 : 20  }"
                        >
                            <a-input
                                :disabled="!canModify"
                                v-decorator="['identity_number', {rules: []}]"
                                :placeholder="getLabel('INFORMATION_RIGHT3_TIP')"
                                size="large"/>
                        </a-form-item>
                        <div>
                            <Upload
                                :maxSize="20"
                                :tip="getLabel('FLIGHT_UPLOAD1')"
                                :wrongTip="getLabel('TIP_OVER_SIZE2')"
                                :uploadType="8"
                                @change="addIdCard"
                                v-if="flightObj['passport_id'] && flightObj['passport_id'].length < 10"
                            />
                            <div
                                class="flight-imgBox"
                                v-for="(img, index) in flightObj['passport_id']" :key="index + '_imgIdcard'"
                            >
                                <a-popconfirm
                                    :title="getLabel('TIP_DELETE')"
                                    @confirm="deleteIdCard(img.id)"
                                    :okText="getLabel('TIP_DELETE_YES')"
                                    :cancelText="getLabel('TIP_DELETE_NO')"
                                >
                                    <i class="flight-imgDelete"></i>
                                </a-popconfirm>
                                <div class="flight-imgWrapper">
                                    <img v-if="isImage(img.url)" :src="img.url" @click="showPreview(img.url)"/>
                                    <div v-else class="flight-docWrapper">
                                        <a-icon type="folder" :style="{
                                            color: '#2099F3',
                                            fontSize: '50px'
                                        }"/>
                                        <p>{{img.name}}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <p class="section-paragraph" style="margin-left: -7px; padding-top: 10px; clear: both;">{{getLabel('FLIGHT_ATTENTION0')}}</p>
                        <ol>
                            <li class="section-paragraph section-indent">{{getLabel('FLIGHT_ATTENTION1')}}</li>
                            <li class="section-paragraph section-indent">{{getLabel('FLIGHT_ATTENTION2')}}</li>
                            <li class="section-paragraph section-indent">{{getLabel('FLIGHT_ATTENTION3')}}</li>
                        </ol>
                    </a-row>
                    <a-form-item
                        :label="getLabel('HOTEL_LABEL3')"
                        :labelCol="{ span: language === 'zh' ? 1 : 2 }"
                        :wrapperCol="{ span: language === 'zh' ? 23 : 22 }"
                    >
                        <a-input
                            :disabled="!canModify"
                            v-decorator="['remark', {rules: []}]"
                            :placeholder="getLabel('HOTEL_LABEL4')"
                            size="large"/>
                    </a-form-item>
                    <div class="flight-agreement">
                        <i class="flight-check" :class="{active: agreeTerm}" @click="toggleItemAgree"></i>
                        {{getLabel('FLIGHT_WARN')}}
                    </div>
                </div>
            </div>
            <div class="flight-section"  :class="{active: flightObj.book_mode === 2}" v-if="language !== 'zh'" >
                <div class="flight-header" @click="toggleSheet(2)">
                    {{getLabel('FLIGHT_SECTION_TITLE2_PRE')}}
                    <span class="strong">{{getLabel('FLIGHT_SECTION_TITLE2_STRONG')}}</span>
                    {{getLabel('FLIGHT_SECTION_TITLE2_AFTER')}}
                </div>
                <div class="flight-content" v-if="flightObj.book_mode === 2">
                    <ol style="margin-left: 20px;">
                        <li class="section-paragraph">{{getLabel('FLIGHT_CASH_GUIDE1')}}</li>
                        <li class="section-paragraph">{{getLabel('FLIGHT_CASH_GUIDE2')}}</li>
                        <li class="section-paragraph">{{getLabel('FLIGHT_CASH_GUIDE3')}}</li>
                        <li class="section-paragraph">{{getLabel('FLIGHT_CASH_GUIDE4')}}</li>
                    </ol>
                    <ul style="margin-left: 40px;">
                        <li class="section-paragraph">
                            {{getLabel('FLIGHT_CASH_GUIDE41_PRE')}}
                            <span class="section-money">{{getLabel('FLIGHT_CASH_GUIDE41_CONTENT')}}</span>
                            {{getLabel('FLIGHT_CASH_GUIDE41_AFTER')}}
                        </li>
                        <li class="section-paragraph">
                            {{getLabel('FLIGHT_CASH_GUIDE42_PRE')}}
                            <span class="section-money">{{getLabel('FLIGHT_CASH_GUIDE42_CONTENT')}}</span>
                            {{getLabel('FLIGHT_CASH_GUIDE42_AFTER')}}
                        </li>

                        <li class="section-paragraph">
                            {{getLabel('FLIGHT_CASH_GUIDE43_PRE')}}
                            <span class="section-money">{{getLabel('FLIGHT_CASH_GUIDE43_CONTENT')}}</span>
                            {{getLabel('FLIGHT_CASH_GUIDE43_AFTER')}}
                        </li>
                    </ul>
                    <div style="margin-top: 20px;" class="clearfix">
                        <Upload
                            :maxSize="20"
                            :tip="getLabel('FLIGHT_UPLOAD2')"
                            :wrongTip="getLabel('TIP_OVER_SIZE2')"
                            :uploadType="4"
                            @change="addItinerary"
                            v-if="flightObj['Itinerary_id'] && flightObj['Itinerary_id'].length < 10"
                        />
                        <div
                            class="flight-imgBox"
                            v-for="(img, index) in flightObj['Itinerary_id']" :key="index + '_imgItinerary1'"
                        >
                            <a-popconfirm
                                :title="getLabel('TIP_DELETE')"
                                @confirm="deleteItinerary(img.id)"
                                :okText="getLabel('TIP_DELETE_YES')"
                                :cancelText="getLabel('TIP_DELETE_NO')"
                            >
                                <i class="flight-imgDelete"></i>
                            </a-popconfirm>
                            <div class="flight-imgWrapper">
                                <img v-if="isImage(img.url)" :src="img.url" @click="showPreview(img.url)"/>
                                <div v-else class="flight-docWrapper">
                                    <a-icon type="folder" :style="{
                                            color: '#2099F3',
                                            fontSize: '50px'
                                        }"/>
                                    <p>{{img.name}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="flight-section" :class="{active: flightObj.book_mode === 3}">
                <div class="flight-header" @click="toggleSheet(3)">{{getLabel('FLIGHT_SECTION_TITLE3')}}</div>
                <div class="flight-content" v-show="flightObj.book_mode === 3">
                    <ol style="margin-left: 20px;">
                        <li class="section-paragraph">{{getLabel('FLIGHT_CASH_GUIDE1')}}</li>
                        <li class="section-paragraph">{{getLabel('FLIGHT_TRANSFER_GUIDE2')}}</li>
                        <li class="section-paragraph">{{getLabel('FLIGHT_CASH_GUIDE3')}}</li>
                        <li class="section-paragraph">{{getLabel('FLIGHT_CASH_GUIDE4')}}</li>
                    </ol>
                    <ul style="margin-left: 40px;">
                        <li class="section-paragraph">
                            {{getLabel('FLIGHT_CASH_GUIDE41_PRE')}}
                            <span class="section-money">{{getLabel('FLIGHT_CASH_GUIDE41_CONTENT')}}</span>
                            {{getLabel('FLIGHT_CASH_GUIDE41_AFTER')}}
                        </li>
                        <li class="section-paragraph">
                            {{getLabel('FLIGHT_CASH_GUIDE42_PRE')}}
                            <span class="section-money">{{getLabel('FLIGHT_CASH_GUIDE42_CONTENT')}}</span>
                            {{getLabel('FLIGHT_CASH_GUIDE42_AFTER')}}
                        </li>

                        <li class="section-paragraph">
                            {{getLabel('FLIGHT_CASH_GUIDE43_PRE')}}
                            <span class="section-money">{{getLabel('FLIGHT_CASH_GUIDE43_CONTENT')}}</span>
                            {{getLabel('FLIGHT_CASH_GUIDE43_AFTER')}}
                        </li>
                    </ul>
                    <a-row style="margin-top: 30px;" v-show="language === 'zh'">
                        <a-col :span="16">
                            <a-form-item
                                label='报销币种'
                                :labelCol="{ span: 4 }"
                                :wrapperCol="{ span: 20 }"
                            >
                                <a-input
                                    placeholder="请选择需要报销的币种"
                                    v-decorator="['pay_currency', {rules: [{ required: (flightObj.book_mode === 3 && language === 'zh'), message: getLabel('TIP_REQUIRED') }]}]"
                                    size="large" autocomplete="off"/>
                            </a-form-item>
                            <a-form-item
                                label='报销金额'
                                :labelCol="{ span: 4 }"
                                :wrapperCol="{ span: 20 }"
                            >
                                <a-input
                                    placeholder="请填写您需要报销的机票总价格"
                                    v-decorator="['pay_money', {rules: [{ required: (flightObj.book_mode === 3 && language === 'zh'), message: getLabel('TIP_REQUIRED') }]}]"
                                    size="large" autocomplete="off"/>
                            </a-form-item>
                            <a-form-item
                                label='开户行信息'
                                :labelCol="{ span: 4 }"
                                :wrapperCol="{ span: 20 }"
                            >
                                <a-input
                                    placeholder="请填写您的银行名称（精确到支行）"
                                    v-decorator="['bank_name', {rules: [{ required: (flightObj.book_mode === 3 && language === 'zh'), message: getLabel('TIP_REQUIRED') }]}]"
                                    size="large" autocomplete="off"/>
                            </a-form-item>
                            <a-form-item
                                label='银行卡号'
                                :labelCol="{ span: 4 }"
                                :wrapperCol="{ span: 20 }"
                            >
                                <a-input
                                    placeholder="请填写您的银行卡卡号"
                                    v-decorator="['bank_number', {rules: [{ required: (flightObj.book_mode === 3 && language === 'zh'), message: getLabel('TIP_REQUIRED') }]}]"
                                    size="large" autocomplete="off"/>
                            </a-form-item>
                            <a-form-item
                                label='收款人姓名'
                                :labelCol="{ span: 4 }"
                                :wrapperCol="{ span: 20 }"
                            >
                                <a-input
                                    placeholder="请填写您的收款人姓名"
                                    v-decorator="['pay_name', {rules: [{ required: (flightObj.book_mode === 3 && language === 'zh'), message: getLabel('TIP_REQUIRED') }]}]"
                                    size="large" autocomplete="off"/>
                            </a-form-item>
                        </a-col>
                    </a-row>
                    <a-row style="margin-top: 30px;" v-show="language === 'en'">
                        <a-col :span="24">
                            <a-form-item
                                label='CURRENCY'
                                :labelCol="{ span: 7 }"
                                :wrapperCol="{ span: 17 }"
                            >
                                <a-input
                                    v-decorator="['en_pay_currency', {rules: [{ required: (flightObj.book_mode === 3 && language === 'en'), message: getLabel('TIP_REQUIRED') }]}]"
                                    size="large" autocomplete="off"/>
                            </a-form-item>
                            <a-form-item
                                label='AMOUNT'
                                :labelCol="{ span: 7 }"
                                :wrapperCol="{ span: 17 }"
                            >
                                <a-input
                                    v-decorator="['en_pay_money', {rules: [{ required: (flightObj.book_mode === 3 && language === 'en'), message: getLabel('TIP_REQUIRED') }]}]"
                                    size="large" autocomplete="off"/>
                            </a-form-item>
                            <a-form-item
                                label='BENEFICIARY’S BANK SWIFT CODE'
                                :labelCol="{ span: 7 }"
                                :wrapperCol="{ span: 17 }"
                            >
                                <a-input
                                    v-decorator="['en_pay_bank_code', {rules: [{ required: (flightObj.book_mode === 3 && language === 'en'), message: getLabel('TIP_REQUIRED') }]}]"
                                    size="large" autocomplete="off"/>
                            </a-form-item>
                            <a-form-item
                                label='BENE’S BANK NAME'
                                :labelCol="{ span: 7 }"
                                :wrapperCol="{ span: 17 }"
                            >
                                <a-input
                                    v-decorator="['en_pay_bank_name', {rules: [{ required: (flightObj.book_mode === 3 && language === 'en'), message: getLabel('TIP_REQUIRED') }]}]"
                                    size="large" autocomplete="off"/>
                            </a-form-item>
                            <a-form-item
                                label='BENE’S BANK ADDRESS'
                                :labelCol="{ span: 7 }"
                                :wrapperCol="{ span: 17 }"
                            >
                                <a-input
                                    v-decorator="['en_pay_bank_address', {rules: [{ required: (flightObj.book_mode === 3 && language === 'en'), message: getLabel('TIP_REQUIRED') }]}]"
                                    size="large" autocomplete="off"/>
                            </a-form-item>
                            <a-form-item
                                label='BENE’S ACCOUNT NO/IBAN NO'
                                :labelCol="{ span: 7 }"
                                :wrapperCol="{ span: 17 }"
                            >
                                <a-input
                                    v-decorator="['en_pay_bank_number', {rules: [{ required: (flightObj.book_mode === 3 && language === 'en'), message: getLabel('TIP_REQUIRED') }]}]"
                                    size="large" autocomplete="off"/>
                            </a-form-item>
                            <a-form-item
                                label='BENE’S ACCOUNT NAME'
                                :labelCol="{ span: 7 }"
                                :wrapperCol="{ span: 17 }"
                            >
                                <a-input
                                    v-decorator="['en_pay_name', {rules: [{ required: (flightObj.book_mode === 3 && language === 'en'), message: getLabel('TIP_REQUIRED') }]}]"
                                    size="large" autocomplete="off"/>
                            </a-form-item>
                            <a-form-item
                                label='BENE’S ADDRESS'
                                :labelCol="{ span: 7 }"
                                :wrapperCol="{ span: 17 }"
                            >
                                <a-input
                                    v-decorator="['en_pay_address', {rules: [{ required: (flightObj.book_mode === 3 && language === 'en'), message: getLabel('TIP_REQUIRED') }]}]"
                                    size="large" autocomplete="off"/>
                            </a-form-item>
                            <a-form-item
                                label='E-MAIL ADDRESS'
                                :labelCol="{ span: 7 }"
                                :wrapperCol="{ span: 17 }"
                            >
                                <a-input
                                    v-decorator="['en_pay_email', {rules: [{ required: (flightObj.book_mode === 3 && language === 'en'), message: getLabel('TIP_REQUIRED') }]}]"
                                    size="large" autocomplete="off"/>
                            </a-form-item>
                        </a-col>
                    </a-row>
                    <div style="margin-top: 20px;" class="clearfix">
                        <Upload
                            :maxSize="20"
                            :tip="getLabel('FLIGHT_UPLOAD2')"
                            :wrongTip="getLabel('TIP_OVER_SIZE2')"
                            :uploadType="4"
                            @change="addItinerary"
                            v-if="flightObj['Itinerary_id'] && flightObj['Itinerary_id'].length < 10"
                        />
                        <div
                            class="flight-imgBox"
                            v-for="(img, index) in flightObj['Itinerary_id']" :key="index + '_imgItinerary2'"
                        >
                            <a-popconfirm
                                :title="getLabel('TIP_DELETE')"
                                @confirm="deleteItinerary(img.id)"
                                :okText="getLabel('TIP_DELETE_YES')"
                                :cancelText="getLabel('TIP_DELETE_NO')"
                            >
                                <i class="flight-imgDelete"></i>
                            </a-popconfirm>
                            <div class="flight-imgWrapper">
                                <img v-if="isImage(img.url)" :src="img.url" @click="showPreview(img.url)"/>
                                <div v-else class="flight-docWrapper">
                                    <a-icon type="folder" :style="{
                                            color: '#2099F3',
                                            fontSize: '50px'
                                        }"/>
                                    <p>{{img.name}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="flight-section" :class="{active: flightObj.book_mode === 4}">
                <div class="flight-header" @click="toggleSheet(4)">{{getLabel('FLIGHT_SECTION_TITLE4')}}</div>
            </div>
            <div class="btn-group">
                <a-button type='default' size="large" @click="backToSummary" v-if="isSecondEnter">{{getLabel('TIP_CANCEL')}}</a-button>
                <a-button type='primary' size="large" class="btn-orange" @click="prevStep" v-if="!isSecondEnter">{{getLabel('BUTTON_PREV')}}</a-button>
                <a-button type='default' size="large" @click="skipStep" v-if="!isSecondEnter">{{getLabel('BUTTON_SKIP')}}</a-button>
                <a-button type='primary' size="large" htmlType='submit'>{{getLabel('BUTTON_NEXT')}}</a-button>
            </div>
        </a-form>
        <a-modal width="800px" :visible="isPreviewModalShow" :footer="null" @cancel="hidePreview">
            <img alt="example" style="width: 100%" :src="previewUrl" />
        </a-modal>
    </div>
</template>

<script>
	import {mapState, mapGetters} from 'vuex';
	import debounce from 'lodash/debounce';
	import Progress from '../components/Progress';
	import Language from '../util/language';
	import { washData } from '../util/tools';
	import Upload from '../components/Upload';
	import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN';
	import en_US from 'ant-design-vue/lib/locale-provider/en_US';
	import moment from 'moment';
    import Controller from '../components/Controller';
	const sheet1_all_fields = [
		'from_city', 'go_date', 'go_flight_no', 'go_time_begin',
		'go_time_end', 'to_city', 'return_date', 'return_flight_no',
		'return_time_begin', 'return_time_end'
	];
	const sheet3_all_zh_fields = [
		'pay_currency', 'pay_money', 'bank_name', 'bank_number', 'pay_name'
	];
	const sheet3_all_en_fields = [
		'en_pay_currency', 'en_pay_money', 'en_pay_bank_code', 'en_pay_bank_name',
		'en_pay_bank_address', 'en_pay_bank_number', 'en_pay_name', 'en_pay_bank_address',
		'en_pay_email'
	];
	const allFields = sheet1_all_fields.concat(sheet3_all_en_fields).concat(sheet3_all_zh_fields);
	export default {
		components: {
			Progress,
			Upload
		},
        mixins: [Controller],
		data () {
			let hourList = [];
			this.fetchGoCity = debounce(this.fetchGoCity, 800);
			this.fetchReturnCity = debounce(this.fetchReturnCity, 800);
			for(let i = 0; i < 24; i++) {
				hourList.push(`${i < 10 ? '0' : ''}${i}:00`);
            }
			return {
				form: this.$form.createForm(this),
				zhCN,
				en_US,
				hourList,
				moment,
				agreeTerm: true, // 是否同意条款
                leftChoice: 1, // 出发航班号/时间段
				rightChoice: 1, // 返程航班号/时间段
                timeObj: {}, // 航班时间对象
                initMode: -1
 			}
		},
		mounted() {
			if (!this.hasData) {
				this.$store.dispatch('flight/getFlight');
			} else {
				const formatObj = this.formatInputDate(this.flightObj);
				this.form.setFieldsValue(formatObj);
				this.setTimeObj(formatObj);
			}
			if (this.isSecondEnter) {
				this.initMode = this.flightObj.book_mode || -1;
            }
		},
		computed: {
			...mapState({
				language: state => state.main.language,
				hasData: state => state.flight.hasData,
				flightObj: state => state.flight.flightObj,
				previewUrl: state => state.flight.previewUrl,
				isPreviewModalShow: state => state.flight.isPreviewModalShow,
				currentUser: state => state.main.currentUser,
				isSecondEnter: state => state.main.isSecondEnter,
                flightContent: state => state.main.flight_content,
                flightContentEn: state => state.main.flight_content_en
			}),
			...mapGetters('flight', {
				goCityShowList: 'goCityShowList',
				returnCityShowList: 'returnCityShowList'
			}),
			canModify: function () {
				return !!this.flightObj.is_modify;
			}
		},
		watch: {
			hasData: function () {
				const srcData = Object.assign({}, this.flightObj);
				this.form.setFieldsValue(this.formatInputDate(srcData));
				this.setTimeObj(srcData);
			}
		},
		methods: {
			// 获取描述
			getLabel: function (key) {
				return Language(this.language, key);
			},
			// 展示时间格式转化
			formatInputDate: function (srcDate) {
				srcDate = JSON.parse(JSON.stringify(srcDate));
				const go_date = srcDate['go_date'];
				const return_date = srcDate['return_date'];
				if (!srcDate['go_time_begin']) {
					delete srcDate.go_time_begin;
                }
				if (!srcDate['go_time_end']) {
					delete srcDate.go_time_end;
				}
				if (!srcDate['return_time_begin']) {
					delete srcDate.return_time_begin;
				}
				if (!srcDate['return_time_end']) {
					delete srcDate.return_time_end;
				}
				if (go_date) {
					srcDate['go_date'] = moment(go_date, 'YYYY-MM-DD');
				}
				if (return_date) {
					srcDate['return_date'] = moment(return_date, 'YYYY-MM-DD');
				}
				return srcDate;
			},
			// 提交时间格式化
			formatSubmitDate: function (submitData) {
				const go_date = submitData['go_date'];
				const return_date = submitData['return_date'];
				if (go_date) {
					submitData['go_date'] = go_date.format('YYYY-MM-DD')
				}
				if (return_date) {
					submitData['return_date'] = return_date.format('YYYY-MM-DD');
				}
				return submitData;
			},
            // 切换同意协议
            toggleItemAgree: function () {
				this.agreeTerm = !this.agreeTerm;
            },
            // 切换预订方式
            toggleSheet: function (key) {
				const currentBookMode = this.flightObj['book_mode'] || -1;
				let targetBookMode;
                if (currentBookMode === -1) {
	                targetBookMode = key;
                } else if (currentBookMode !== -1 && currentBookMode !== key) {
	                targetBookMode = key;
                } else {
	                targetBookMode = -1;
                }
	            this.$store.commit('flight/setBookMode', targetBookMode, { root: true });
            },
            // 增加身份证扫描件照片
			addIdCard: function (data) {
				this.$store.commit('flight/addIdCard', data);
            },
            // 删除身份证扫描件
			deleteIdCard: function(id) {
				let _this = this;
				this.$store.dispatch('main/deleteDocument', {
					id,
					callBack: () => {
						_this.$store.commit('flight/deleteIdCard', id);
					}
				});
            },
            // 增加行程单照片
			addItinerary: function (data) {
				this.$store.commit('flight/addItinerary', data);
			},
			// 删除行程单描件
			deleteItinerary: function(id) {
				let _this = this;
				this.$store.dispatch('main/deleteDocument', {
					id,
					callBack: () => {
						_this.$store.commit('flight/deleteItinerary', id);
					}
				});
			},
			// 上一步
			prevStep: function () {
				if (this.language === 'zh') {
					this.$router.push('/activity');
				} else {
					this.$router.push('/en/activity');
				}
			},
			// 跳过
			skipStep: function () {
				this.submitFlightInfo(this.form.getFieldsValue());
			},
			// 下一步
			handleSubmit: function (e) {
				e.preventDefault();
				if (!this.agreeTerm && this.flightObj['book_mode'] === 1) {
					this.$store.commit('main/openMessage', {
						type: 'warning',
						message: this.getLabel('FLIGHT_ALERT')
					}, { root: true });
					return;
                }
				this.form.validateFields(allFields, { force: true });
				this.form.validateFields((err, values) => {
					if (!err) {
						this.submitFlightInfo(values);
					} else {
						document.getElementById('flight-form').scrollIntoView();
                    }
				})
			},
			// 提交
			submitFlightInfo: function (data) {
				data = washData(data);
				data = this.formatSubmitDate(data);
                if ([1, 2, 3, 4].indexOf(this.flightObj['book_mode']) === -1) {
                    // 首次进入可能存在这种情况，预定方式都没选，直接跳过
                    this.nextPage();
                    return;
                }
				this.$store.dispatch('flight/submitFlightInfo', {
                    data,
                    cb: () => {
                        // 如果护照号已填，且和当前登录信息不一致也修改
                        if (data['book_mode'] === 1 && data['identity_number'] && (data['identity_number'] !== this.currentUser['identity_number'])) {
                            this.$store.dispatch('flight/changeIdentityNo', {
                                identity_number: data['identity_number']
                            });
                        }
                        this.nextPage();
                    }
                });

                // if (this.isSecondEnter) {
                // 	this.backToSummary();
                // } else {
	            //     if (this.language === 'zh') {
		        //         this.$router.push('/hotel');
	            //     } else {
		        //         this.$router.push('/en/hotel');
	            //     }
                // }

			},
            // 出发航班号/时间段 变化
			changeLeftChoice: function (value) {
                this.leftChoice = value;
			},
			// 返程航班号/时间段 变化
			changeRightChoice: function (value) {
				this.rightChoice = value;
			},
			backToSummary: function () {
				if (this.initMode !== -1) {
					this.$store.commit('flight/setBookMode', this.initMode, { root: true });
                }
				this.$store.commit('main/backToSummary');
			},
            // 打开图片预览
            showPreview: function (url) {
	            this.$store.commit('flight/setPreviewStatus', true);
	            this.$store.commit('flight/setPreviewUrl', url);
            },
            // 隐藏图片预览
			hidePreview: function () {
				this.$store.commit('flight/setPreviewStatus', false);
				setTimeout(() => {
					this.$store.commit('flight/setPreviewUrl', '');
                }, 300);
			},
			// 设置组件内航班时间对象
			setTimeObj: function (srcData) {
				let currentTimeObj = this.timeObj;
				if (srcData.go_time_begin) {
					currentTimeObj.go_time_begin = srcData.go_time_begin;
				}
				if (srcData.go_time_end) {
					currentTimeObj.go_time_end = srcData.go_time_end;
				}
				if (srcData.return_time_begin) {
					currentTimeObj.return_time_begin = srcData.return_time_begin;
				}
				if (srcData.return_time_end) {
					currentTimeObj.return_time_end = srcData.return_time_end;
				}
				this.timeObj = Object.assign({}, currentTimeObj);
			},
			timeChange: function (key, keyOpposite, value) {
				this.setTimeObj({
					[key]: value
				});
				if(this.timeObj[keyOpposite]) {
					this.form.validateFields([keyOpposite], { force: true });
				}
			},
			// 去程开始航班时间校验
			checkGoTimeBegin(rule, value, callback) {
				const go_time_end = this.timeObj['go_time_end'];
				if (go_time_end) {
					if (value < go_time_end) {
						callback();
					} else {
						callback(this.getLabel('FLIGHT_TIME_COMPARE'));
					}
				} else {
					callback();
				}
			},
			// 返程开始航班时间校验
			checkReturnTimeBegin(rule, value, callback) {
				const return_time_end = this.timeObj['return_time_end'];
				if (return_time_end) {
					if (value < return_time_end) {
						callback();
					} else {
						callback(this.getLabel('FLIGHT_TIME_COMPARE'));
					}
				} else {
					callback();
				}
			},
            // 搜索出发城市
			fetchGoCity(value) {
				this.$store.dispatch('flight/fetchGoCity', value);
            },
            // 搜索返程城市
			fetchReturnCity(value) {
				this.$store.dispatch('flight/fetchReturnCity', value);
			},
            // 判断是否是图片
            isImage(url) {
				// 获取最后一个点的索引
                const LastDotIndex = url.lastIndexOf('.');
                // 获取文件后缀
	            const FileSuffix = url.substring(LastDotIndex);
	            // 图片后缀列表
                const ImageSuffixList = ['.png','.jpg','.jpeg','.bmp','.gif','.webp','.svg','.tiff'];
                // 开始匹配
                let result = false;
                for (let i = 0, len = ImageSuffixList.length; i < len; i++) {
                	let currentSuffix = ImageSuffixList[i];
                	if (FileSuffix.indexOf(currentSuffix) !== -1) {
                		result = true;
                		break;
                    }
                }
                return result;
            }
		}
	};
</script>

<style lang="less" scoped>
    .flight {
        &-form {
            margin-top: 15px;
        }
        &-section {
            margin-bottom: 20px;
            &.active {
                border: 1px solid #2099F3;
                border-radius: 2px;
                .flight-header {
                    border: none;
                    background: url(../assets/img/selection.png) left 20px center #bce0fb no-repeat;
                }
            }
        }
        &-header {
            height: 40px;
            line-height: 40px;
            padding-left: 50px;
            border: 1px solid rgba(0,0,0,0.20);
            border-radius: 2px;
            font-size: 16px;
            color: #333333;
            cursor: pointer;
            background: url(../assets/img/unchecked.png) left 20px center no-repeat;
            background-size: 20px 20px;
            .strong {
                font-weight: bold;
                font-size: 1.2em;
            }
        }
        &-content {
            padding: 20px;
        }
        &-title {
            font-size: 16px;
            color: #333333;
            margin-bottom: 20px;
        }
        &-logo {
            background: url(../assets/img/flight.png) center center no-repeat;
        }
        &-noInput {
            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
        }
        &-dark {
            padding: 20px 20px 30px;
            margin-bottom: 20px;
            background: #BCE0FB;
            border-radius: 6px;
            .ant-input {
                background: none;
                border: 1px solid rgba(0,0,0,0.20);
                &::-webkit-input-placeholder {
                    color: #999;
                }
            }
        }
        &-agreement {
            font-size: 14px;
            font-weight: bold;
            color: #F36F20;
            padding-left: 26px;
            position: relative;
            i {
                width: 16px;
                height: 16px;
                cursor: pointer;
                display: inline-block;
                background: url(../assets/img/unchecked.png) center center no-repeat;
                background-size: 16px;
                position: absolute;
                top: 2px;
                left: 0;
                &.active {
                    background: url(../assets/img/selection.png) center center no-repeat;
                    background-size: 16px;
                }
            }
        }
        &-imgBox {
            position: relative;
            overflow: visible;
            width: 230px;
            height: 150px;
            margin-left: 10px;
            margin-bottom: 10px;
            display: inline-block;
            border: 1px solid #F2F2F2;
            cursor: pointer;
            &:nth-child(3n + 1) {
                margin-left: 0;
            }
        }
        &-imgWrapper {
            overflow: hidden;
            position: absolute;
            width: 100%;
            height: 100%;
            img {
                width: 100%;
                height: auto;
                top: 50%;
                position: relative;
                transform: translateY(-50%);
            }
        }
        &-docWrapper {
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            text-align: center;
            background: #f2f2f2;
        }
        &-imgDelete {
            display: block;
            width: 20px;
            height: 20px;
            position: absolute;
            right: -10px;
            top: -10px;
            background: url(../assets/img/delete_file.png) center center no-repeat;
            background-size: 100%;
            z-index: 10;
            cursor: pointer;
        }
    }
    .slide-fade-enter-active {
        transition: all .8s ease;
    }
    .slide-fade-leave-active {
        transition: all 0s ease;
    }
    .slide-fade-enter, .slide-fade-leave-to
        /* .slide-fade-leave-active for below version 2.1.8 */ {
        transform: translateY(0);
    }
    .clearfix:after {
        content: '';
        display: block;
        clear: both;
    }
    .section-money {
        font-weight: bold;
        font-size: 1.2em;
        margin: 0 5px;
        color: #333;
    }
</style>

<style lang="less">
    .flight-logo .ant-input-group{
        .ant-select-selection-selected-value {
            line-height: 40px;
        }
        .ant-input-disabled {
            padding: 6px 5px;
            text-align: center;
        }
    }
    .left-hour-picker>div {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
    }
    .time-picker-row .ant-form-explain {
        position: absolute;
        white-space: nowrap;
    }
</style>
